import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import CalendarAlertIcon from 'Assets/Images/calendar-alert.svg';
import {
  fetchDataFromLinkQueryParam, fetchProjectedMeetingFromQueryParam,
  setNewLinkQueryParam,
  useAgentSchedulerDispatchContext, useAgentSchedulerStateContext,
} from 'Context/NewAgentSchedulerContext';
import moment from 'moment-timezone';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { addQueryWithReplace } from 'Helpers/Query';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.facet.primaryGray,
    height: '100%',
  },
  header: {
    color: theme.palette.facet.accentBlue2,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.common.white,
    padding: theme.spacing(8, 4, 8, 4),
  },
  desktopContainer: {
    borderRadius: theme.radius.md,
    width: '33%',
  },
  body: {
    margin: theme.spacing(2),
    textAlign: 'center',
  },
  scheduleMeetingButton: {
    marginTop: theme.spacing(1),
  },
  calendarAlertIcon: {
    marginBottom: theme.spacing(2),
  },
});

const UnableToSchedule = ({
  classes,
  className,
}) => {
  const { householdResource } = useSimpleHousehold();
  const dispatch = useAgentSchedulerDispatchContext();
  const { responseErrors } = useAgentSchedulerStateContext();
  let error;
  if (responseErrors) {
    [error] = responseErrors;
  }

  const handleScheduleMeetingButtonClick = async () => {
    const [nextProjectedMeeting] = await householdResource.relationship(fr.relationships.projectedMeetings.name).link('related').Get({
      params: {
        tz: moment.tz.guess(),
      },
    });
    setNewLinkQueryParam(dispatch, nextProjectedMeeting.relationship(fr.relationships.projectedMeetingAvailabilityPeriod.name).link('related').url());
    addQueryWithReplace({ projectedMeetingLink: nextProjectedMeeting.link('self').url() });
    fetchDataFromLinkQueryParam(dispatch);
    fetchProjectedMeetingFromQueryParam(dispatch, nextProjectedMeeting.link('self').url());
  };


  return (
    <div className={classNames(classes.root, className)}>
      <div className={classNames(classes.container)}>
        <img className={classes.calendarAlertIcon} src={CalendarAlertIcon} />
        <Typography variant="h2" className={classes.header}>
          Unable to schedule meeting
        </Typography>
        <Typography variant="body" className={classes.body}>
          {error?.detail}
          <br />
          Please click the button below to schedule a new meeting.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.scheduleMeetingButton}
          onClick={handleScheduleMeetingButtonClick}
        >
          Schedule meeting
        </Button>
      </div>
    </div>
  );
};

UnableToSchedule.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

UnableToSchedule.defaultProps = {
  className: '',
};

export default withStyles(styles)(UnableToSchedule);
